import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { orderBy } from "lodash";

// components (global)
import { Page } from "components/Pages";
import { CustomTabs } from "components/Tabs";

// components (local)
import { Resident, Visitor, Logs } from "./components";

// material-ui
import { Container, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// styles
const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    paddingTop: theme.spacing(3),
  },
  content: {},
}));

const Card = () => {
  const classes = useStyles();

  // selector
  const roles = useSelector((state) => state.main.roles);

  // state
  const [tabs, setTabs] = useState([]);

  // effect
  useEffect(() => {
    var tab = [];

    if (roles.access_card?.resident?.read) {
      tab = [
        ...tab,
        {
          value: "resident",
          label: "Resident",
          content: <Resident />,
          sorting: 0,
        },
      ];
    }

    if (roles.access_card?.visitor?.read) {
      tab = [
        ...tab,
        {
          value: "visitor",
          label: "Visitor",
          content: <Visitor />,
          sorting: 1,
        },
      ];
    }
    if (roles.access_card?.resident?.read) {
      tab = [
        ...tab,
        {
          value: "Logs",
          label: "Logs",
          content: <Logs />,
          sorting: 2,
        },
      ];
    }

    setTabs(tab);
  }, [roles.access_card]);

  return (
    <Page className={classes.root} title="Access Card">
      <Container maxWidth={false}>
        <Grid
          alignItems="flex-end"
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography component="h1" gutterBottom variant="overline">
              Access Card
            </Typography>
          </Grid>
        </Grid>

        <CustomTabs
          tabs={orderBy(tabs, ["sorting"], ["asc"])}
          defaultTabIndex={0}
        />
      </Container>
    </Page>
  );
};

export default Card;
